import createPersistedState from "vuex-persistedstate";
import userStoreModule from "./user";
import globalStoreModule from "./global";

window.addEventListener("storage", event => {
  if (event.key === "vuex") {
    const newState = Object.assign(
      {},
      window.store.state,
      JSON.parse(event.newValue)
    );
    window.store.replaceState(newState);
  }
});

// function to check the existance of session storage
function canWriteSessionStorage() {
  try {
    window.sessionStorage.setItem("@@", 1);
    window.sessionStorage.removeItem("@@");
    return true;
  } catch (e) {
    return false;
  }
}

// persist the vuex store's data to session storage
let plugins = [];
if (canWriteSessionStorage()) {
  plugins = [
    createPersistedState({
      key: "vuex",
      paths: ["user", "global"],
      storage: window.sessionStorage
    })
  ];
}

export default {
  modules: {
    user: userStoreModule,
    global: globalStoreModule
  },
  plugins
};
